module.exports = __webpack_public_path__ + "img/search-top.57c94103.svg";